import React from "react";
import cn from "classnames";
import styles from "./Carousel.module.sass";
import SubscribeButton from "../../../components/SubscribeButton";

const Carousel = () => {
    return (
        <div className={styles.carousel}>
            <div className={styles.videoWrapper}>
                <video className={styles.video} autoPlay loop muted playsInline>
                    <source src="/videos/zova/banner.webm" type="video/webm" />
                    <source src="/videos/zova/banner.mp4" type="video/mp4" />
                </video>
            </div>
            <div className={cn("container", styles.container)}>
                <div className={styles.wrap}>
                    <h1 className={cn("h1", styles.title)}>
                        Longevity Made Simple.
                    </h1>
                    <div className={styles.text}>
                        Get Science-backed, personalized & actionable instructions for your health goals, budget, and lifestyle and live smarter.
                    </div>
                    <div className={styles.btns}>
                        <div className={styles.buttonGroup}>
                            <a
                                href="https://71qjlbfvzsh.typeform.com/to/PywktTOr"
                                className={cn("button", styles.button)}
                            >
                                Register Now
                            </a>
                            <a
                                href="https://71qjlbfvzsh.typeform.com/to/yioAajOE"
                                className={cn("button", styles.button)}
                            >
                                Supplement Analyzer
                            </a>
                        </div>
                        <SubscribeButton
                            source="carousel"
                            buttonText="Lifestyle Analyzer"
                            className={styles.secondaryButton}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Carousel;
